/*
  초기화면 ( home )
    OWL Start

*/
import React from "react";
import "./Home.css";
import LoaderButton from "../components/LoaderButton";
import NotificationComponent from "../components/NotificationComponent"; // NotificationComponent 임포트

import { Auth } from 'aws-amplify';
import config from '../config';

export default function Home(props) {

  function handleClick(e) {
    e.preventDefault();
    // 생성정보 확인하여 팝업 띄우기.
    Auth.currentAuthenticatedUser({
      bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).then( user => {
      var accessToken = user.signInUserSession.getAccessToken().getJwtToken();
      var url = config.owl_callback.starter;
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'accessToken';
      input.value = accessToken;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    }).catch( err => {
      console.log("catch( err => {");
      console.log(err);
      //alert ("ログインをお願いします。") ;
      props.history.push("/login");
     });

  }

  return (
    <div className="Home">
      <div className="lander">
        <h1>医療機関向けクラウド版チェックアイDXレセプトチェッカー</h1>
          <LoaderButton block onClick={handleClick} bsSize="large" >
             Ｓｔａｒｔ
          </LoaderButton>

          <NotificationComponent /> {/* NotificationComponent 사용 */}

      </div>
    </div>
  );
}
